import Vue from 'formVueLp1';

new Vue({
  el: '.l-wrapper'
});
